import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';

import api from '../../../services/api';
import Input from '../../Inputs/Input';

import { Container, Content, FormView } from './styles';

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  places: any;
  handlePlacesNum: any;
}

const ModalPerfilNumero: React.FC<ModalPARAMS> = ({
  id = 'modalPerfilNumero',
  onClose = () => {},
  isVisible,
  places,
  handlePlacesNum,
}) => {
  /* const handleOutSideClick = useCallback(
    e => {
      if (e.target.id === id) {
        setVisible(false);

        setTimeout(() => {
          onClose();
        }, 300);
      }
    },
    [id, onClose],
  ); */
  const handleOnClose = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const formRef = useRef<FormHandles>(null);

  useEffect(() => {
    formRef.current?.getFieldRef('num').focus();
  }, [places]);

  const handleSubmit = useCallback(
    async (data: any) => {
      if (places![0].address_components[0]?.types[0] !== 'street_number') {
        const number = {
          long_name: data.num,
          short_name: data.num,
          types: ['street_number'],
        };
        const aux = [];
        aux.push(number);

        places![0].address_components.map((item: any) => {
          aux.push(item);
          return item;
        });

        places![0].address_components = aux;

        places![0].formatted_address = places![0].formatted_address.replace(
          places![0].address_components[1].short_name,
          `${places![0].address_components[1].short_name}, ${data.num}`,
        );
      }

      await api
        .post('portal/matrix/location', {
          end: places[0].formatted_address,
        })
        .then(response => {
          handlePlacesNum(places, response.data);
          handleOnClose();
        });
    },
    [places, handlePlacesNum, handleOnClose],
  );

  const handleSemNumero = useCallback(async () => {
    if (places![0].address_components[0]?.types[0] !== 'street_number') {
      const number = {
        long_name: '',
        short_name: '',
        types: ['street_number'],
      };

      const aux = [];
      aux.push(number);

      places![0].address_components.map((item: any) => {
        aux.push(item);
        return item;
      });

      places![0].address_components = aux;
    }

    await api
      .post('portal/matrix/location', {
        end: places[0].formatted_address,
      })
      .then(response => {
        handlePlacesNum(places, response.data);
        handleOnClose();
      });
  }, [places, handlePlacesNum, handleOnClose]);

  const [visible, setVisible] = useState(isVisible);

  return (
    <Container id="modalPerfilNumero">
      <Content className={`${visible ? 'active' : ''}`}>
        <h1>Falta Pouco pra localizarmos seu endereço.</h1>
        <h2>Digite o número do local.</h2>

        <FormView ref={formRef} onSubmit={handleSubmit}>
          <div className="input">
            <p>
              Número <span>(obrigatório)</span>
            </p>
            <Input name="num" placeholder="Número" />
          </div>

          <button className="btn-buscar">Buscar</button>

          <button type="button" onClick={handleSemNumero}>
            Sem número
          </button>
        </FormView>
      </Content>
    </Container>
  );
};

export default ModalPerfilNumero;
